"use client";
/**
 * Dev-mode live reload toggle, shown on public pages when CMS_DEV_MODE=true.
 * Polls the page/post/media/chrome version and reloads when it changes (theme
 * code itself already hot-reloads through `next dev`).
 */
import { useEffect, useState } from "react";

export function DevReload() {
  const [on, setOn] = useState(false);

  useEffect(() => {
    setOn(localStorage.getItem("cms-dev-reload") === "1");
  }, []);

  useEffect(() => {
    if (!on) return;
    let version = "";
    const tick = async () => {
      try {
        const r = await fetch("/api/dev/version");
        if (!r.ok) return;
        const d = await r.json();
        if (version && d.version !== version) location.reload();
        version = d.version;
      } catch {
        /* server restarting — keep polling */
      }
    };
    tick();
    const t = setInterval(tick, 2000);
    return () => clearInterval(t);
  }, [on]);

  return (
    <aside className="cms-dev-toolbar" aria-label="Ontwikkelmodus" style={{ padding: 14, position: "relative", zIndex: 1 }}><button
      onClick={() => {
        const next = !on;
        setOn(next);
        localStorage.setItem("cms-dev-reload", next ? "1" : "0");
      }}
      title="Ontwikkelmodus: vernieuw deze pagina automatisch wanneer inhoud, koptekst of voettekst verandert"
      style={{
        background: on ? "#27b376" : "#181d2b", color: "#fff",
        border: 0, borderRadius: 99, padding: "8px 14px", fontSize: 12,
        cursor: "pointer", boxShadow: "0 4px 14px rgba(0,0,0,.3)",
      }}
    >
      ⟳ Automatisch vernieuwen {on ? "aan" : "uit"}
    </button></aside>
  );
}
